import * as yup from "yup";

// yup.addMethod(
//   yup.array,
//   "unique",
//   function (
//     message,
//     mapper = (a) => a.Answer?.toLowerCase() || a.Question?.toLowerCase()
//   ) {
//     return this.test("unique", message, function (list) {
//       return list.length === new Set(list.map(mapper)).size;
//     });
//   }
// );

yup.addMethod(
  yup.array,
  "unique",
  function (
    message,
    mapper = (a) => a.Answer?.toLowerCase() || a.Question?.toLowerCase(),
  ) {
    return this.test("unique", message, function (list) {
      const newList =
        list[0]?.Answer || list[0]?.Answer === ""
          ? list.filter((a) => a.Answer !== "")
          : list[0]?.Question
            ? list
            : [];
      // console.log(newList, list);
      // console.log(
      //   newList?.length,
      //   newList.length === new Set(newList.map(mapper)).size
      // );
      return newList?.length === 0
        ? true
        : newList.length === new Set(newList.map(mapper)).size;
    });
  },
);
yup.addMethod(yup.array, "answerImageRequired", function (message) {
  return this.test("answerImageRequired", message, function (list) {
    let count = 0;
    let isValid = true;
    list?.forEach((element) => {
      if (element.AnswerImage !== "") {
        isValid = false;
        count++;
      }
    });
    if (isValid) {
      return true;
    } else {
      return count === list?.length ? true : false;
    }
  });
});

export const detailsSchema = yup.object().shape({
  Language: yup.string(),
  // TrainingType: yup.string().required("Training Type is required!"),
  TrainingType: yup
    .array(
      yup.object().shape({
        Name: yup.string(),
        TypeId: yup.number(),
      }),
    )
    .min(1, "Training Type is required!"),

  Name: yup
    .string()
    .trim()
    .required("Name is required!")
    .max(70, "Only 70 characters allowed!"),
  Tags: yup.string().required(),
});

export const addQuizSchema = yup.object().shape({
  QuestionsList: yup
    .array()
    .of(
      yup.object().shape({
        Question: yup
          .string()
          .trim()
          .required("Question is required!")
          .max(250, "Only 250 characters allowed"),
        QuestionImage: yup.mixed().notRequired(),
        ActiveQuestionType: yup.number(),
        IsCorrect: yup
          .string()
          .trim()
          .required("Please select the right answer")
          .nullable(),
        // TrueOrFalse: yup.boolean().required("Answer option is required!"),
        // MultiSelect: yup.boolean().notRequired(),
        Explanation: yup
          .string()
          .trim()
          .notRequired()
          .max(250, "Only 250 characters allowed"),
        Duration: yup.number().notRequired(),
        EnableTimer: yup.boolean().notRequired().default(false),
        QuizDuration: yup
          .number()
          .nullable()
          .transform((value, originalValue) => {
            // If the original value is empty string, null, undefined, or NaN, return null
            if (
              originalValue === "" ||
              originalValue == null ||
              isNaN(originalValue)
            ) {
              return null;
            }
            return value;
          })
          .notRequired(),
        AnswersList: yup.array().when("ActiveQuestionType", {
          is: 1,
          then: yup
            .array()
            .of(
              yup.object().shape({
                Answer: yup.string().when(["AnswerImage"], {
                  is: (AnswerImage) => !!AnswerImage,
                  then: yup
                    .string()
                    .trim()
                    .required("Answer is required!")
                    .max(60, "Only 60 characters allowed"),
                  otherwise: yup
                    .string()
                    .trim()
                    .required("Answer is required!")
                    .max(250, "Only 250 characters allowed"),
                }),
                AnswerImage: yup.mixed().notRequired(),
              }),
            )
            .unique("Same choice already exists")
            .answerImageRequired("Please upload images for all choices")
            .min(2, "Please create atleast two choices"),
          otherwise: yup.array().of(
            yup.object().shape({
              Answer: yup.string(),
              AnswerImage: yup.mixed().notRequired(),
            }),
          ),
        }),
      }),
    )
    .unique("Same question already exists."),
  Duration: yup.number("Only numbers allowed"),
  EnableTimer: yup.boolean().notRequired().default(false),
  QuizDuration: yup
    .number()
    .nullable()
    .transform((value, originalValue) => {
      if (
        originalValue === "" ||
        originalValue == null ||
        isNaN(originalValue)
      ) {
        return null;
      }
      return value;
    })
    .notRequired()
    .min(0, "Duration must be a positive number")
    .max(1800, "Duration cannot exceed 1800 seconds")
    .integer("Decimals are not allowed"),
});

export const passcodeSchema = yup.object().shape({
  instructor: yup.string().required("Please select instructor"),
  event: yup.string().required("Please select event"),
  fromDate: yup.string().required("Please select start date"),
  toDate: yup.string().required("Please select end date"),
  passcode: yup.string().trim().required("Please enter passcode"),
});
